"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.data = [
    {
        collationId: 1,
        estimatedTimeOfArrival: '2019-01-17 02:00:00+00',
        id: 1,
        totalDelay: undefined,
    },
    {
        collationId: 1,
        estimatedTimeOfArrival: '2019-01-17 03:00:00+00',
        id: 2,
        totalDelay: undefined,
    },
    {
        collationId: 2,
        estimatedTimeOfArrival: '2019-01-17 02:00:00+00',
        id: 3,
        shipmentId: 2,
        totalDelay: undefined,
    },
    {
        collationId: 3,
        estimatedTimeOfArrival: '2019-01-17 02:00:00+00',
        id: 4,
        totalDelay: undefined,
    },
    {
        collationId: 4,
        estimatedTimeOfArrival: '2019-01-17 02:00:00+00',
        id: 5,
        totalDelay: undefined,
    },
    {
        collationId: 5,
        estimatedTimeOfArrival: '2019-01-17 02:00:00+00',
        id: 6,
        totalDelay: undefined,
    },
];
